import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function EditorialNotesCard({ label, value, hint, className = '' }) {
  const classes = ['ed-notes-card', className].filter(Boolean).join(' ');
  return (
    <aside className={classes}>
      {label ? <div className="ed-notes-card__label">{label}</div> : null}
      {value ? <div className="ed-notes-card__value">{value}</div> : null}
      {hint ? (
        <>
          <div className="ed-notes-card__divider" />
          <div className="ed-notes-card__hint">{hint}</div>
        </>
      ) : null}
    </aside>
  );
}

EditorialNotesCard.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  hint: PropTypes.node,
  className: PropTypes.string,
};
